// JSON.stringify replacer that handles bigints, viem-style contract proxies, and circular
// references. Kept dependency-free so error/debug surfaces don't drag the sim runtime in.
export function makeSafeReplacer(): (key: string, value: unknown) => unknown {
  const seen = new WeakSet<object>();
  return function (_key: string, value: unknown): unknown {
    if (typeof value === 'bigint') return value.toString() + 'n';
    if (typeof value === 'object' && value !== null) {
      if ('_contractAddress' in (value as object)) {
        const v = value as { _contractAddress?: unknown };
        const addr = typeof v._contractAddress === 'string' ? v._contractAddress : undefined;
        const name = (value as object).constructor?.name ?? 'Contract';
        return `[${name}@${addr ?? '?'}]`;
      }
      if (seen.has(value as object)) return '[Circular]';
      seen.add(value as object);
    }
    return value;
  };
}
